import moment from 'moment';

/**
 * Calculate the previous day with special handling for weekends
 * Monday, Saturday, Sunday -> Friday
 * Other days -> Previous day
 */
export function getPreviousDayDate(currentDate) {
  const currentDay = moment(currentDate).day(); // 0 = Sunday, 1 = Monday, 6 = Saturday
  let daysToSubtract = 1;

  if (currentDay === 1) {
    // Monday -> Friday
    daysToSubtract = 3;
  } else if (currentDay === 0) {
    // Sunday -> Friday
    daysToSubtract = 2;
  } else if (currentDay === 6) {
    // Saturday -> Friday
    daysToSubtract = 1;
  }

  return moment(currentDate).subtract(daysToSubtract, 'day');
}

/**
 * Get date range for orders
 */
export function getDateRange(date, daysOffset = 0) {
  const targetDate = moment(date).add(daysOffset, 'day');
  return {
    from: targetDate.format('YYYY-MM-DD'),
    to: targetDate.add(1, 'day').format('YYYY-MM-DD'),
  };
}
